module.exports = __webpack_public_path__ + "static/media/info-button.7156dbb6.svg";